module.exports = __webpack_public_path__ + "img/10_jobs-and-careers.5fcebc99.png";